import React, { useState } from "react";
import { TextField, Button, Typography, Box, InputAdornment, Grid, Paper, IconButton, FormControl, Alert, Dialog, DialogTitle, DialogContent, DialogActions, Divider } from "@mui/material";
import { useForm } from "react-hook-form";
import { IconCheck, IconCloudLockOpen, IconEye, IconEyeOff, IconX } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import loginIllustration from ".././graphic.svg";
import axios from "axios";
import { BeatLoader } from "react-spinners";
import PageContainer from "../Pages/Pagecontainer";
// import Logo from '.././Images/logo1.png'
import Logo from '.././Images/logo-dark.png'

const ForgotPassword = () => {
  const { register, handleSubmit, formState: { errors }, trigger, getValues ,setValue} = useForm();
  const navigate = useNavigate();
  const [showOtpField, setShowOtpField] = useState(false);
  const [showpasswordscreen, setshowpasswordscreen] = useState(true);
  const { register: registerpassword, handleSubmit: handlepassword, watch, trigger: triggerpassword, formState: { errors: passworderror } } = useForm();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setloading] = useState(false);
  const [loading2, setloading2] = useState(false);
  const [error, seterror] = useState('');
  const [token, settoken] = useState('');
  const [otperror, setotperror] = useState('');
  const [userid, setuserid] = useState('')
  const [open, setopen] = useState(false)
  const [reloader,setreloader]= useState(false)
  const [showmessage,setShowMessage]= useState('')
  const onSubmit = async (data) => {
    setloading(true);
    try {
        let config = axios.defaults.headers.common = { 'Authorization': `` };
        
        if (!showOtpField) {
            let req = { email: data.email };
            const response = await axios.post('apiV1/forgot_passwordV2/', req, config);

            if (response.status === 200) {
                setShowOtpField(true);
                setShowMessage("Verification Code  sent to the email address you entered");
                settoken(response.data.token);
            }
        } else {
            let req = { otp: getValues("otp"), token: token };
            const response = await axios.post('apiV1/check_otp/', req, config);

            if (response.status === 200) {
                setshowpasswordscreen(false);
                setuserid(response.data.user_id);
            }
        }
    } catch (error) {
        if (!showOtpField) {
            seterror(error.response?.data?.detail || "Failed to send Verification Code");
        } else {
            setotperror(error.response?.data?.message || "Invalid Verification Code");
        }
    } finally {
        setloading(false);
    }
};


  const resendotp = async () => {
    setValue("otp", "")
    seterror(null)
    setotperror(null)
    setreloader(true)
    setShowMessage('')
    try {
      const Email = getValues("email");
      let req = {
        email: Email,
      };
      let config = axios.defaults.headers.common = { 'Authorization': `` }
      const response = await axios.post('apiV1/forgot_passwordV2/', req, config);
      if (response.status == 200) {
        settoken(response.data.token)
        setreloader(false)
        setShowMessage("Verification Code sent to the email address you entered")
      }
      console.log(response);
    } catch (error) {
      seterror(error.response.data?.detail);
      setreloader(false)
      console.error('Error generating test:', error.response ? error.response.data : error.message);
    }
  }
  const onotpSubmit = async (data) => {
    setloading2(true)
    try {
      const Otp = getValues("otp");
      let req = {
        otp: Otp,
        token: token
      };
      let config = axios.defaults.headers.common = { 'Authorization': `` }
      const response = await axios.post('apiV1/check_otp/', req, config);
      if (response.status == 200) {
        // setshowpasswordChange(true)
        // setSecondscreen(false)
        setshowpasswordscreen(false)
        setuserid(response.data.user_id)
        setloading2(false)
      }
      console.log(response);
    } catch (error) {
      console.error(error)
      setloading2(false)
      setotperror(error.response.data.message)
    }

  };
  const onPasswordSubmit = async (data) => {
    setloading(true)
    try {
      console.log(data);

      let req = {
        password: data.password,
        password2: data.confirmPassword
      };
      let config = axios.defaults.headers.common = { 'Authorization': `` }
      const response = await axios.patch(`apiV1/change-passwordv2/${userid}/`, req, config);
      if (response.status == 200) {
        // setshowpasswordChange(true)
        setopen(true)
        setloading(false)
      }
      console.log(response);
    } catch (error) {
      console.error('Error generating test:', error.response ? error.response.data : error.message);
      setloading(false)

    }

  };
  return (
    <>
      <PageContainer title="SmartInvestorDeck | ForgotPassword">
      <Grid container justifyContent="center" alignItems="center" height="100vh" sx={{ backgroundImage: `url(${loginIllustration})`, backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "45%" }}>
        <Paper elevation={3} sx={{ borderRadius: 3, overflow: "hidden", maxWidth: 400, width: "100%", padding: 4, background: "rgba(255, 255, 255, 0.9)", backdropFilter: "blur(10px)" }}>
          <Box sx={{ textAlign: "center", mb: 2 }}>
          <img src={Logo} alt="logo" style={{ width: "250px" }} />
            {/* <IconButton sx={{ backgroundColor: "#4b75fd", color: "white", padding: 3, "&:hover": { backgroundColor: "#4b75fd" } }}>
              <IconCloudLockOpen color="#fff" size={50} />
            </IconButton> */}
          </Box>
          {showpasswordscreen ? (
            <Box>
              <Typography variant="h5" fontWeight="bold" textAlign="center" gutterBottom>
                Forgot Your Password?
              </Typography>
              <Typography variant="body2" textAlign="center" sx={{ mb: 2 }}>
                Enter your email and we will send you instructions to reset your password.
              </Typography>

              <form onSubmit={handleSubmit(onSubmit)}>
                <FormControl variant="standard" fullWidth margin="dense">
                  <Typography variant="body2" gutterBottom>Email</Typography>
                  <TextField
                    fullWidth
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                        message: "Enter a valid email",
                      },
                    })}
                    onKeyUp={() => { trigger("email"); seterror(''); }}
                    error={!!errors.email}
                    disabled={loading || showOtpField}
                    helperText={errors.email?.message}
                  />
                </FormControl>

                {showOtpField && (
                  <FormControl variant="standard" fullWidth margin="dense">
                    <Typography variant="body2" gutterBottom>Enter Verification Code</Typography>
                    <TextField
                      fullWidth
                      placeholder="Enter Verification Code"
                      {...register("otp", {
                        required: "Verification Code is required",
                        pattern: {
                          value: /^\d{1,6}$/,
                          message: "Verification Code must be 1 to 6 digits",
                        },
                      })}
                      inputProps={{
                        maxLength: 6,
                        minLength: 6,
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                      }}
                      error={!!errors.otp}
                      helperText={errors.otp?.message}
                      onKeyUp={() => { trigger("otp"); setotperror(''); setShowMessage("") }}
                    />
                  </FormControl>

                )}

                <Box sx={{ mt: 2 }}>
                  {error && <Alert severity="error">{error}</Alert>}
                  {otperror && <Alert severity="error">{otperror}</Alert>}
                </Box>

              {showmessage && <Alert severity="success" sx={{mt:2}}>{showmessage}</Alert>}
                <Button type="submit" variant="contained" fullWidth sx={{ mt: 2, }} disabled={loading} className="button2">
                  {loading ? <BeatLoader size={20} color="#fff" /> : <Typography>Confirm</Typography>}
                </Button>
              </form>
              {showOtpField && (
                <Box>
                  {/* <Button type="submit" variant="contained" fullWidth onClick={onotpSubmit} sx={{ mt: 2 }} disabled={loading || loading2 || reloader}>
                    {loading2 ? <BeatLoader size={20} color="#77b0d1" /> : <Typography>Confirm</Typography>}
                  </Button> */}
                  <Button type="submit" variant="contained" fullWidth onClick={resendotp} sx={{ mt: 2 }} disabled={loading || loading2 || reloader} className="button2">
                    {reloader ? <BeatLoader size={20} color="#77b0d1" /> : <Typography>Resend Verification Code</Typography>}
                  </Button>
                </Box>
              )}
              <Typography
                variant="body2"
                textAlign="center"
                sx={{ mt: 2, display: "flex", justifyContent: "center" }}
              >
                Remember your password?
                <Typography
                  component="span"
                  variant="body2"
                  sx={{ color: "#07659c", ml: 1, cursor: "pointer" }}
                  onClick={() => navigate("/")}
                >
                  Back to Sign In
                </Typography>
              </Typography>
            </Box>
          ) : (
            <Box>
              <Typography variant="h5" fontWeight="bold" textAlign="center" gutterBottom>
                Reset Your Password
              </Typography>
              <Typography variant="body2" textAlign="center" sx={{ mb: 2 }}>
                Enter your new password below and confirm it to reset your account password.
              </Typography>
              <form
                onSubmit={handlepassword(onPasswordSubmit)}
                autoComplete="off"
                autoCorrect="off"
                spellCheck="false"
              >
                {/* Hidden field to trick browser autocomplete */}
                <input type="text" style={{ display: 'none' }} />
                <input type="password" style={{ display: 'none' }} />

                <FormControl variant="standard" fullWidth>
                  <Typography variant="body2" gutterBottom>Password</Typography>
                  <TextField
                    fullWidth
                    id="new-password"
                    type={showPassword ? "text" : "password"}
                    inputProps={{
                      autoComplete: "new-password",
                      autoCorrect: "off",
                      spellCheck: "false",
                      autoCapitalize: "none"
                    }}
                    {...registerpassword("password", {
                      required: "Password is required",
                      pattern: {
                        value: /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,16}$/,
                        message: "Password must be 8-16 characters, with at least one digit, one lowercase, and one uppercase letter.",
                      },
                    })}
                    onKeyUp={() => triggerpassword("password")}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                            {showPassword ?   <IconEye />:<IconEyeOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    error={!!passworderror.password}
                    helperText={passworderror.password?.message}
                  />
                </FormControl>

                {/* Confirm Password Field */}
                <FormControl variant="standard" fullWidth margin="dense">
                  <Typography variant="body2" gutterBottom>Confirm Password</Typography>
                  <TextField
                    fullWidth
                    id="confirm-password-input"
                    type={showConfirmPassword ? "text" : "password"}
                    inputProps={{
                      autoComplete: "new-password",
                      autoCorrect: "off",
                      spellCheck: "false",
                      autoCapitalize: "none"
                    }}
                    {...registerpassword("confirmPassword", {
                      required: "Confirm Password is required",
                      validate: (value) => value === watch("password") || "Passwords do not match",
                    })}
                    onKeyUp={() => triggerpassword("confirmPassword")}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
                            {showConfirmPassword ?  <IconEye />:<IconEyeOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    error={!!passworderror.confirmPassword}
                    helperText={passworderror.confirmPassword?.message}
                  />
                </FormControl>

                {/* Submit Button */}
                <Button type="submit" variant="contained" fullWidth sx={{ mt: 2, bgcolor: "#07659c" }} className="button2">
                    {loading ? <BeatLoader size={20} color="#fff" /> : <Typography>Update Password</Typography>}
                </Button>
              </form>
            </Box>
          )}

        </Paper>
      </Grid>
      <Dialog open={open} onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          setopen(false);
        }
      }} fullWidth>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          Success
        </DialogTitle>
        <Divider />

        <DialogContent sx={{ textAlign: "center" }}>
          <Box sx={{ textAlign: "center", mb: 2 }}>
            <IconButton sx={{ backgroundColor: "#c6f1d1", color: "white", padding: 3, "&:hover": { backgroundColor: "#4b75fd" } }}>
              <IconCheck color="#198b08" size={50} />
            </IconButton>
          </Box>
          Your password has been updated successfully!
        </DialogContent>
        <Divider />
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          <Button onClick={() => navigate('/')} color="success" variant="contained" className="button2">
            Okay
          </Button>
        </DialogActions>
      </Dialog>
      </PageContainer>
    </>
  );
};

export default ForgotPassword;
